import { render, staticRenderFns } from "./CulturalContentYjj.vue?vue&type=template&id=a122a9ea&scoped=true&"
import script from "./CulturalContentYjj.vue?vue&type=script&lang=js&"
export * from "./CulturalContentYjj.vue?vue&type=script&lang=js&"
import style0 from "./CulturalContentYjj.vue?vue&type=style&index=0&id=a122a9ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a122a9ea",
  null
  
)

export default component.exports